import TrackWrapper from '~/components/common/TrackWrapper';
import { Content } from '../styles';

export type ComponentProps = {
  className?: string;
};

type OwnProps = {
  CTAButton: React.ComponentType<ComponentProps>;
  HeroImage: React.ComponentType<ComponentProps>;
  subheadingText: string;
  title: string;
  viewEvent: {
    eventName: string;
  };
};

export default function CommonHero({
  CTAButton,
  HeroImage,
  title,
  subheadingText,
  viewEvent
}: OwnProps) {
  return (
    <TrackWrapper event={viewEvent}>
      <div className="bg-white pb-56">
        <div className="grid h-[350px] w-full gap-2xl sm:h-[403px] sm:gap-3xl md:h-[716px]">
          <HeroImage className="z-0" />
          <div className="z-1 col-span-full row-span-full mx-auto w-full px-2xl pt-2xl sm:px-3xl sm:pt-56 md:w-[752px] md:pt-64 md:text-center">
            <h3 className="max-w-[286px] t-brand-sm sm:max-w-max sm:t-brand-lg">
              {title}
            </h3>
            <div className="hidden gap-2xl pt-2xl md:flex md:flex-col md:items-center">
              <Content>{subheadingText}</Content>
              <CTAButton />
            </div>
          </div>
        </div>
        <div className="grid gap-2xl px-2xl sm:px-3xl sm:pt-3xl md:hidden">
          <Content>{subheadingText}</Content>
          <CTAButton className="w-full sm:w-[225px]" />
        </div>
      </div>
    </TrackWrapper>
  );
}
